/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIMeta
 */
export interface APIMeta {
    /**
     * 
     * @type {APIPagination}
     * @memberof APIMeta
     */
    pagination?: APIPagination;
}

/**
 * Check if a given object implements the APIMeta interface.
 */
export function instanceOfAPIMeta(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function APIMetaFromJSON(json: any): APIMeta {
    return APIMetaFromJSONTyped(json, false);
}

export function APIMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pagination': !exists(json, 'pagination') ? undefined : APIPaginationFromJSON(json['pagination']),
    };
}

export function APIMetaToJSON(value?: APIMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pagination': APIPaginationToJSON(value.pagination),
    };
}

